var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactCardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B3CAF7",
    fillRule: "nonzero",
    d: "M2.002 10C.898 10 0 10.895 0 12v32c0 1.1.898 2 2.002 2h41.996C45.102 46 46 45.105 46 44V12c0-1.1-.898-2-2.002-2H2.002z",
    transform: "translate(-157 -441) translate(8 409) translate(149 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD63E",
    d: "M5 21c0-.552.445-1 1-1h14c.552 0 1 .445 1 1v14c0 .552-.445 1-1 1H6c-.552 0-1-.445-1-1V21z",
    transform: "translate(-157 -441) translate(8 409) translate(149 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M23 7c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zm5-2c0-2.761-2.239-5-5-5s-5 2.239-5 5v8.002c0 .552.446.998.995.998h8.01c.54 0 .995-.447.995-.998V5z",
    transform: "translate(-157 -441) translate(8 409) translate(149 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7896D2",
    d: "M26 22c0-.552.45-1 1.007-1h11.986c.556 0 1.007.444 1.007 1 0 .552-.45 1-1.007 1H27.007C26.45 23 26 22.556 26 22zM26 28c0-.552.45-1 1.007-1h11.986c.556 0 1.007.444 1.007 1 0 .552-.45 1-1.007 1H27.007C26.45 29 26 28.556 26 28zM26 34c0-.552.438-1 1.003-1h4.994c.554 0 1.003.444 1.003 1 0 .552-.438 1-1.003 1h-4.994C26.449 35 26 34.556 26 34z",
    transform: "translate(-157 -441) translate(8 409) translate(149 32)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCardLogo);
export default __webpack_public_path__ + "static/media/contactCardLogo.c05dffc3b32d7c1e01b604c54dde1e96.svg";
export { ForwardRef as ReactComponent };